import { RedirectResolver } from '../../../Foundation/Base/Pipelines/Resolving/RedirectResolver'
import { RedirectResolverResponse } from '../../../Foundation/Base/Pipelines/Resolving/RedirectResolverResponse'
import { RedirectResolverRequest } from '../../../Foundation/Base/Pipelines/Resolving/RedirectResolverRequest'
import { extractObjectIdFromPath } from '../../../Foundation/Lots/extractObjectIdFromUri'
import { languageCodeMapping } from '../../../Foundation/LotApi/Settings/LanguageCodeMapping'
import queryString from 'query-string'
import { consts } from '../consts'
import { LotApiResult } from '../../../Foundation/LotApi/Models/LotApiResult'
import { LotService } from '../../../Foundation/LotApi/Services/LotService'

export class LotResolver implements RedirectResolver {
  constructor(private lotService: LotService) {}

  async process(request: RedirectResolverRequest): Promise<RedirectResolverResponse> {
    const lotId = extractObjectIdFromPath(request.url)
    const calendarUrl = request.sitecore.context[consts.CalendarPageUrl] as string

    if (!lotId) {
      return { shouldRedirect: true, redirectUrl: calendarUrl }
    }

    const serviceResult = await this.lotService.getLotFromHttpRequest(request)

    if (!serviceResult?.object_id) {
      return { shouldRedirect: true, redirectUrl: calendarUrl }
    }

    if (serviceResult.redirect_url) {
      return this.getRedirectObjectFromLotAPI(serviceResult, request)
    }
    return { shouldRedirect: false, redirectUrl: null }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  private getRedirectObjectFromLotAPI(serviceResult: LotApiResult, request: RedirectResolverRequest) {
    const targetUrl = serviceResult.redirect_url

    const requestParameters = request.query
    const parsedTargetUrl = queryString.parseUrl(targetUrl)

    for (const parameter of Object.keys(requestParameters)) {
      parsedTargetUrl.query[parameter] = requestParameters[parameter]
    }

    const sitecoreLanguage = parsedTargetUrl.query['sc_lang']

    if (!sitecoreLanguage) {
      const languageId = requestParameters['lid']
      if (languageId) {
        const newSitecoreMapping = languageCodeMapping.find((x) => x.lotAPI == languageId)
        if (!newSitecoreMapping?.sitecore) throw `Missing value of languageCodeMapping.sitecore for ${languageId}`
        const newSitecoreLanguage = newSitecoreMapping?.sitecore

        parsedTargetUrl.query['sc_lang'] = newSitecoreLanguage
      }
    }

    const targetUrlWithNewQueryString = queryString.stringifyUrl({
      url: targetUrl,
      query: parsedTargetUrl.query,
    })
    return { shouldRedirect: true, redirectUrl: targetUrlWithNewQueryString }
  }
}

//  DON'T DELETE - used by DW
